import { currentEnvironment } from './env';

type RequestConfig = {
  baseUrl: string;
  baseUrlWL: string;
  aiBotBaseUrl: string;
  publicUrl: string;
  dtCallbackUrl: string;
  searchUrl: string;
  socketUrl: string;
  qsS3BucketName: string;
  qsS3BucketRegion: string;
  qsS3Domain: string;
  qsCloudFrontDomain: string;
  redirectUrl: string;
  qsApiUrl: string;
  smsServiceUrl: string;
  botBuilderBaseUrl: string;
};

let requestConfig: RequestConfig;

if (currentEnvironment === 'production') {
  requestConfig = {
    baseUrl: 'https://api.doubletickapi.com',
    baseUrlWL: 'https://api.appmix.co',
    aiBotBaseUrl: 'https://api2.doubletickapi.com',
    redirectUrl: 'https://web.doubletick.io',
    dtCallbackUrl: 'https://doubletick.io',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow.doubletickapi.com',
  };
} else if (currentEnvironment === 'production-local') {
  requestConfig = {
    baseUrl: 'https://api.doubletickapi.com',
    baseUrlWL: 'https://api.appmix.co',
    aiBotBaseUrl: 'https://api2.doubletickapi.com',
    redirectUrl: 'https://web.doubletick.io',
    dtCallbackUrl: 'https://doubletick.io',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else if (currentEnvironment === 'production-2') {
  requestConfig = {
    baseUrl: 'https://api.doubletickapi.com',
    baseUrlWL: 'https://api.appmix.co',
    aiBotBaseUrl: 'https://api2.doubletickapi.com',
    redirectUrl: 'https://desktop.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://doubletick.io',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else if (currentEnvironment === 'apiStaging') {
  requestConfig = {
    baseUrl: 'https://api-staging.doubletick.io',
    baseUrlWL: 'https://api-staging-3.doubletick.io',
    aiBotBaseUrl: 'https://ai-staging-2.doubletick.io',
    redirectUrl: 'https://desktop.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://doubletick.io',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket-staging.doubletick.io',
    qsApiUrl: 'https://api-staging.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else if (currentEnvironment === 'apiStaging2') {
  requestConfig = {
    baseUrl: 'https://api-staging-2.doubletick.io',
    baseUrlWL: 'https://api-staging-2.doubletick.io',
    aiBotBaseUrl: 'https://api2.doubletickapi.com',
    redirectUrl: 'https://desktop.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://doubletick.io',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api-staging-2.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else if (currentEnvironment === 'apiStaging3') {
  requestConfig = {
    baseUrl: 'https://api-staging-4.doubletick.io',
    baseUrlWL: 'https://api-staging-4.doubletick.io',
    aiBotBaseUrl: 'https://api2.doubletickapi.com',
    redirectUrl: 'https://desktop.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://doubletick.io',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api-staging-3.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else if (currentEnvironment === 'stagingWithProd') {
  requestConfig = {
    baseUrl: 'https://api.doubletickapi.com',
    baseUrlWL: 'https://api.doubletickapi.com',
    aiBotBaseUrl: 'https://ai-staging-2.doubletick.io',
    redirectUrl: 'https://desktop.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://dt-staging.dev.quicksell.co',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else if (currentEnvironment === 'staging2WithProd') {
  requestConfig = {
    baseUrl: 'https://api.doubletickapi.com',
    baseUrlWL: 'https://api.doubletickapi.com',
    aiBotBaseUrl: 'https://ai-staging-2.doubletick.io',
    redirectUrl: 'https://desktop-2.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://dt-staging.dev.quicksell.co',
    publicUrl: 'https://merchant.api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://socket.doubletick.io',
    qsApiUrl: 'https://api.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://getsmsotp.com',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
} else {
  requestConfig = {
    baseUrl: 'https://api-9.doubletick.dev',
    // baseUrl: 'https://api-1.doubletick.dev',
    baseUrlWL: 'https://api-9.doubletick.dev',
    // aiBotBaseUrl: 'https://ai-2.doubletick.dev',
    aiBotBaseUrl: 'https://ai-9.doubletick.dev',
    redirectUrl: 'https://desktop.crm.dev.quicksell.co',
    dtCallbackUrl: 'https://dt-staging.dev.quicksell.co',
    publicUrl: 'https://merchant.api.quicksell.co',
    qsApiUrl: 'https://api.quicksell.co',
    searchUrl: 'https://search.quicksell.co',
    socketUrl: 'https://crm-socket.dev.quicksell.co',
    qsS3BucketName: 'quicksales',
    qsS3BucketRegion: 'ap-south-1',
    qsS3Domain: 'https://s3.amazonaws.com/quicksales',
    qsCloudFrontDomain: 'https://cdn.quicksell.co',
    smsServiceUrl: 'https://sms-service.dev.quicksell.co',
    botBuilderBaseUrl: 'https://flow-staging.doubletick.io',
  };
}

export default requestConfig;
